import installLegacyPublicRouteCompatibility from './legacyPublicRouteCompatibility'
import registerUserRouteRefreshGuard from './userRouteRefreshGuard'
import registerPersonalSettingsRoutes from './personalSettingsRoutes'
import registerSecuritySettingsRoutes from './securitySettingsRoutes'
import registerPublicRouteReferenceRoutes from './publicRouteReferenceRoutes'

const TheContainer = () => import('@/containers/TheContainer')
const PlatformContractManagement = () => import('@/views/platform/PlatformContractManagement')
const ProviderRoleManagement = () => import('@/views/platform/ProviderRoleManagement')
const PlatformNotices = () => import('@/views/platform/PlatformNotices')
const NationalHolidayMaster = () =>
  import('@/views/platform/NationalHolidayMaster')
const AccountInvitation = () => import('@/views/pages/AccountInvitation')

export default function registerPlatformAccessRoutes (router) {
  // 既存の汎用数値`:id`より先にUUID専用ルートを登録する。
  // この関数はmain.jsで最初に呼ばれる動的ルート登録処理なので、
  // 後続のProvider/Tenant/通知ルートを失わずmatcherを先頭拡張できる。
  registerPublicRouteReferenceRoutes(router)

  // 動的に追加する公開招待ルートを、F5・メール直リンク時も未ログインで表示する。
  installLegacyPublicRouteCompatibility(router)
  registerUserRouteRefreshGuard(router)
  registerPersonalSettingsRoutes(router)
  registerSecuritySettingsRoutes(router)
  router.addRoutes([
    {
      path: '/account-invitation',
      name: '契約企業管理者招待',
      component: AccountInvitation,
      meta: { public: true }
    },
    {
      path: '/platform',
      component: TheContainer,
      children: [
        {
          path: 'access-management',
          name: '契約企業管理',
          component: PlatformContractManagement,
          meta: { requiresAuth: true, platformSuperAdmin: true }
        },
        {
          path: 'provider-role-management',
          name: 'PREIKA運営権限管理',
          component: ProviderRoleManagement,
          meta: { requiresAuth: true, platformSuperAdmin: true }
        },
        {
          // 全社のダッシュボードに出るお知らせ。**書けるのは運営だけ。**
          path: 'notices',
          name: '運営からのお知らせ',
          component: PlatformNotices,
          meta: { requiresAuth: true, platformSuperAdmin: true }
        },
        {
          /*
           * 全社共通の祝日マスタ。**触れるのは運営だけ。**
           *
           * ここが埋まっていれば契約企業は祝日を入力しなくてよい。
           * 逆に、切れた翌日から全社の祝日が平日になる——
           * 勤務表の色も、法定休日の集計も、月末予測も、
           * 誰も気づかないままずれる。
           */
          path: 'national-holidays',
          name: '祝日マスタ',
          component: NationalHolidayMaster,
          meta: { requiresAuth: true, platformSuperAdmin: true }
        }
      ]
    }
  ])
}
